import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../api-urls";

// Function to get Auth Token
const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  console.log("Auth Token:", token); // Debugging
  return token ? `Bearer ${token}` : null;
};

// Fetch Cart Items
// export const fetchCartItems = async() => {
//   try {
//     const token = getAuthToken();
//     if (!token) throw new Error("Unauthorized: No auth token");

//     console.log("Fetching cart items...");
//     const response = await axios.get(API_ENDPOINTS.cart, { headers: { Authorization: token } });
//     console.log("Cart items fetched:", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching cart items:", error);
//     return error;
//   }
// }
// export const fetchCartItems = createAsyncThunk("cart/fetchCartItems", async (_, { rejectWithValue }) => {
//   try {
//     const token = getAuthToken();
//     if (!token) throw new Error("Unauthorized: No auth token");

//     console.log("Fetching cart items...");
//     const response = await axios.get(API_ENDPOINTS.cart, { headers: { Authorization: token } });
//     console.log("Cart items fetched:", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching cart items:", error);
//     return rejectWithValue(error.message);
//   }
// });
// Fetch Cart Items
export const fetchCartItems = createAsyncThunk(
  "cart/fetchCartItems",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      if (!token) throw new Error("Please login first");
      
      const response = await axios.get(API_ENDPOINTS.cart, {
        headers: { Authorization: token },
      });
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Add Item to Cart
export const addToCart = createAsyncThunk(
  "cart/addToCart",
  async ({ variantId, size, quantity = 1, color, customSizeId }, { dispatch, rejectWithValue }) => {
    try {
      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized: No auth token");
      if (!variantId) return rejectWithValue("Variant ID is required");
      
      const payload = {
        color: color || "Red",
        variant_id: Number(variantId),
        quantity: Number(quantity),
        ...(size && { size }),
        ...(customSizeId && { custom_size_id: customSizeId }),
      };
      
      const response = await axios.post(API_ENDPOINTS.cart, payload, {
        headers: { Authorization: token },
      });
      
      dispatch(fetchCartItems());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add item");
    }
  }
);

// Increment/Decrement Cart Item
// export const incrementDecrementCart = createAsyncThunk(
//   "cart/incrementDecrementCart",
//   async ({ variantId, size, color, incrementOrDecrementAction, customSizeId }, { dispatch, rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       if (!token) throw new Error("Unauthorized: No auth token");
//       if (!variantId) return rejectWithValue("Variant ID is required");

//       const payload = {
//         color: color || "Red",
//         variant_id: Number(variantId),
//         action: incrementOrDecrementAction,
//         ...(size && { size }),
//         ...(customSizeId && { custom_size_id: customSizeId }),
//       };

//       const response = await axios.put(API_ENDPOINTS.cart, payload, {
//         headers: { Authorization: token },
//       });

//       dispatch(fetchCartItems());
//       return response.data?.message || "Cart updated successfully"; // ✅ Return only a string message
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || "Failed to update item");
//     }
//   }
// );

export const incrementDecrementCart = createAsyncThunk(
  "cart/incrementDecrementCart",
  async ({ cartId, incrementOrDecrementAction }, { dispatch, rejectWithValue }) => {
    try {
      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized: No auth token");
      if (!cartId) return rejectWithValue("Cart ID is required"); // ✅ Ensure cartId is sent

      const payload = {
      //  variant_id: variantId,
        cart_id: cartId, // ✅ Use cart_id instead of variant_id
        action: incrementOrDecrementAction
      };

      const response = await axios.put(API_ENDPOINTS.cart, payload, {
        headers: { Authorization: token },
      });

      dispatch(fetchCartItems());
      return response.data?.message || "Cart updated successfully";
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update item");
    }
  }
);




// Remove Item from Cart
export const removeFromCart = createAsyncThunk(
  "cart/removeFromCart",
  async ({ cartId
    //product_id, size, color,  custom_size_data 

  }, { dispatch, rejectWithValue }) => {
    try {
      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized: No auth token");
      // console.log("product_id--", product_id, "size----", size, "color-----", color, "custom_size_data----", custom_size_data);
      // console.log(typeof(size))
      // Ensure that either `size` or `custom_size_data` is present
      // if (!product_id || !color || (size===" " && !custom_size_data)) { // ✅ Fix condition
        // return rejectWithValue("Variant ID, color, and either size or custom size data are required");
      // }
      

      // const data = {
      //   variant_id: product_id, // Ensure correct key name
      //   color,
      //   ...(size && { size }), // Include `size` if present
      //   // ...(customSizeId && { custom_size_id: customSizeId }),
      //   ...(custom_size_data && { custom_size_data }), // Include `custom_size_data` if present
      // };
      const data = {
        "cart_id":cartId
      };

      console.log("Sending DELETE request with data:", data);

      const response = await axios.delete(API_ENDPOINTS.cart, {
        headers: { Authorization: token },
        data, // Ensure the backend supports DELETE requests with a body
      });

      dispatch(fetchCartItems());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to remove item from cart");
    }
  }
);


export const clearCartAPI = createAsyncThunk(
  "cart/clearCart",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      console.log("🗑 Clearing cart...");
      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized: No auth token");

      const response = await axios.delete(`${API_ENDPOINTS.cart}/clearCart`, {
        headers: { Authorization: token },
      });
      console.log("✅ Cart cleared successfully:", response.data);
      dispatch(clearCart());
      dispatch(fetchCartItems());

      return response.data;
    } catch (error) {
      console.error(
        "❌ Error clearing cart:",
        error.response?.data || error.message
      );
      return rejectWithValue(error.response?.data || "Failed to clear cart");
    }
  }
);

export const toggleCartItemSelectionAPI = createAsyncThunk(
  "cart/toggleCartItemSelection",
  async (cartId, { dispatch, rejectWithValue }) => {
    try {
      console.log(`🔄 Toggling selection for cart item: ${cartId}...`);

      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized: No auth token");

      const response = await axios.post(
        `${API_ENDPOINTS.cart}/selectCartItem/${cartId}`,
        {},
        { headers: { Authorization: token } }
      );
      
      console.log("✅ Cart item selection toggled:", response.data);
      dispatch(fetchCartItems());



      const updatedCartItem = response.data.data.products.find(
        (item) => item.cart_id === cartId
      );

      if (updatedCartItem) {
        dispatch(
          updateCartItemSelection({
            cartId,
            isSelected: updatedCartItem.isSelected ?? false,
          })
        );
      } else {
        console.warn(`Cart item with ID ${cartId} not found in response.`);
      }

      

      return response.data;
    } catch (error) {
      console.error(
        "❌ Error toggling cart item selection:",
        error.response?.data || error.message
      );
      return rejectWithValue(
        error.response?.data || "Failed to toggle cart item selection"
      );
    }
  }
);

// Cart Slice
const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cartItems: [],
    totalCount: 0,
    subTotal: 0,
    loading: false,
    error: null,
    isCartOpen: false,
    gst: 0,
    couponCode: "",
    discount: 0,
    discountOnMrp: 0,
  },
  reducers: {
    clearCart: (state) => {
      state.cartItems = [];
      console.log("🛒 Cart cleared");
    },
    openCart: (state) => {
      state.isCartOpen = true;
      console.log("🛒 Cart slider opened");
    },
    closeCart: (state) => {
      state.isCartOpen = false;
      console.log("🛒 Cart slider closed");
    },
    updateTotalCount: (state) => {
      state.totalCount = state.cartItems.reduce(
        (sum, item) => sum + (item.quantity || 0),
        0
      );
    },
    updateCartItemSelection: (state, action) => {
      const { cartId, isSelected } = action.payload;
      const item = state.cartItems.find((item) => item.cart_id === cartId);
      if (item) {
        item.isSelected = isSelected;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCartItems.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCartItems.fulfilled, (state, action) => {
        state.loading = false;
        // if (Array.isArray(action.payload)) {
        //   state.cartItems = action.payload;
        // } else
        if (action.payload && Array.isArray(action.payload.data.cartDetails)) {
          state.cartItems = action.payload.data.cartDetails;
        } else {
          state.cartItems = [];
          console.error("Unexpected API response format:", action.payload);
        }
        state.totalCount = state.cartItems.reduce(
          (sum, item) => sum + (item.quantity || 0),
          0
        );
        state.subTotal =
          action.payload?.data?.sub_total;
          //  ||
          // state.cartItems.reduce(
          //   (sum, item) => sum + (item.discount_price * item.quantity || 0),
          //   0
          // );
          state.gst =action.payload?.data?.gst;
          state.discount = action.payload?.data?.discount;
          state.discountOnMrp = action.payload?.data?.discount_on_mrp;
          state.couponCode = action.payload?.data?.coupon_code;
        console.log("✅ Cart items loaded into state:", action.payload);
        state.error = false;
      })
      .addCase(fetchCartItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(incrementDecrementCart.pending, (state) => {
        state.loading = true;
      })
      .addCase(incrementDecrementCart.fulfilled, (state, action) => {
        state.loading = false;
        // const { id, quantity } = action.payload;
        // const itemIndex = state.cartItems.findIndex((item) => item.id === id);
        // if (itemIndex !== -1) {
        //   state.cartItems[itemIndex].quantity = quantity;
        //   console.log(`✅ Cart item updated: ${id} → ${quantity}`);
        // }
      })
      .addCase(incrementDecrementCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addToCart.pending, (state) => {
        state.loading = true;
      })
      .addCase(addToCart.fulfilled, (state, action) => {
        state.loading = false;
        // state.cartItems.push(action.payload);
        console.log("✅ Item added to cart in state");
      })
      .addCase(addToCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(removeFromCart.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeFromCart.fulfilled, (state, action) => {
        state.loading = false;
        const itemId = action.payload;
        state.cartItems = state.cartItems.filter((item) => item.id !== itemId);
        console.log(`✅ Cart item removed: ${itemId}`);
      })
      .addCase(removeFromCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(clearCartAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(clearCartAPI.fulfilled, (state) => {
        state.loading = false;
        state.cartItems = [];
      })
      .addCase(clearCartAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(toggleCartItemSelectionAPI.fulfilled, (state, action) => {
        console.log("🔄 Cart item selection updated successfully", action.payload);
      });
  },
});


export const { clearCart, openCart, closeCart, updateTotalCount,updateCartItemSelection } =
  cartSlice.actions;
export default cartSlice.reducer;

